var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-collapse',{staticClass:"collapse",model:{value:(_vm.actives),callback:function ($$v) {_vm.actives=$$v},expression:"actives"}},[_c('el-collapse-item',{attrs:{"title":"Controllability","name":1}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }